import { Segmented } from 'antd';

/**
 * The card-definition sub-editor for a `location` element's one option
 * (docs/plans/data-types.md decision 5):
 *
 *   accept    what the element will hold — an address, a pair of
 *             coordinates, or `both` (the default, and the answer for almost
 *             every card).
 *
 * It is worth narrowing for the two cards that mean one thing exactly: a
 * delivery address is never a latitude, and a trail marker or a mooring is
 * never a street. Narrowing also shapes the ENTRY control — an element that
 * takes only coordinates shows the two numbers outright instead of hiding
 * them behind the address box — and it is enforced on write, so a value that
 * arrives by import or automation is refused the same way a typed one is.
 *
 * The default is written as ABSENT rather than as the word 'both': an option
 * nobody set should not appear in the stored card, and the contract reads a
 * missing `accept` as `both` on every side.
 */

export const ACCEPT_OPTIONS = [
	{ value: 'both', label: 'Both' },
	{ value: 'address', label: 'Address' },
	{ value: 'coordinates', label: 'Coordinates' },
];

export default function LocationOptions({ index, element, onChange, basePath = null }) {
	const options = element?.options || {};
	const prefix = `${basePath || `elements[${index}]`}.options`;
	const value = ACCEPT_OPTIONS.some(o => o.value === options.accept) ? options.accept : 'both';

	return (
		<div className='location-options'>
			<div className='micro-label card-def-element__section'>Location</div>
			<div className='mb-2'>
				<label className='d-block' htmlFor={`${prefix}.accept`}>Accepts</label>
				<Segmented
					id={`${prefix}.accept`}
					options={ACCEPT_OPTIONS}
					value={value}
					onChange={next => onChange(`${prefix}.accept`, next === 'both' ? undefined : next)}
					aria-label='Accepts'
				/>
				<div className='form-panel__hint'>
					Both is the usual answer. Narrow it when the field means one thing
					exactly — a mailing address, or a point on a map.
				</div>
			</div>
		</div>
	);
}
